<!--
  app/components/pages/how-to-play/HtpIconStopwatch.vue
-->
<script setup lang="ts">
import { useNuxtApp } from "#imports";

const { $t } = useNuxtApp();

const props = withDefaults(
  defineProps<{
    width?: number;
    height?: number;
  }>(),
  { width: 120, height: 137 }
);
</script>

<template>
  <svg
    :width="props.width"
    :height="props.height"
    viewBox="0 0 430 490"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
  >
    <path
      d="M25.6322 275.083C25.6322 170.544 110.378 85.7982 214.917 85.7982C271.583 85.7982 322.425 110.706 357.114 150.161L375.709 132.478C336.339 88.119 278.893 60.1653 214.917 60.1653C96.2216 60.1653 0 156.388 0 275.083C0 335.175 24.6642 389.506 64.4202 428.507L83.0152 410.825C47.6271 376.431 25.6322 328.329 25.6322 275.083Z"
      fill="currentColor"
    />
    <path
      d="M375.71 132.477L357.115 150.161C386.422 183.494 404.203 227.209 404.203 275.082C404.203 379.622 319.457 464.367 214.917 464.367C163.625 464.367 117.106 443.956 83.0156 410.824L64.4207 428.507C103.192 466.543 156.314 490 214.917 490C333.613 490 429.835 393.778 429.835 275.082C429.835 220.362 409.385 170.419 375.71 132.477Z"
      fill="currentColor"
      fill-opacity="0.47"
    />
    <rect x="165.101" width="95.6666" height="48.7563" rx="19.5025" fill="currentColor" />
    <path
      d="M93.0722 86.0218L52.5481 113.858C49.0607 116.253 44.2489 115.36 41.8532 111.873L27.5235 91.0112C25.1284 87.5238 26.0215 82.7113 29.5082 80.3162L70.0324 52.4803C73.5191 50.0852 78.3316 50.9783 80.7267 54.465L95.0569 75.3275C97.452 78.8142 96.559 83.6267 93.0722 86.0218Z"
      fill="currentColor"
    />
    <path
      d="M371.926 111.654L335.426 84.4061C331.24 81.2804 330.372 75.298 333.497 71.1115L346.475 53.7272C349.6 49.5408 355.583 48.6727 359.769 51.7978L396.269 79.0464C400.455 82.1715 401.323 88.1539 398.198 92.3403L385.22 109.725C382.094 113.911 376.112 114.78 371.926 111.654Z"
      fill="currentColor"
    />
    <!-- "2" -->
    <path
      d="M126.269 312.45V286.423C126.269 262.364 131.956 240.274 194.509 222.776L219.223 215.996C242.626 210.091 247.219 205.935 247.219 198.936V198.718C247.219 190.844 241.97 184.501 216.38 184.501C185.541 184.501 183.573 200.249 182.917 207.685H129.112V206.154C129.112 184.282 139.173 147.538 210.256 147.538H221.192C284.182 147.538 302.117 169.847 302.117 198.718V200.467C302.117 229.557 282.651 241.805 233.659 250.553C224.91 252.303 215.724 254.053 208.069 255.803C176.355 262.364 171.106 267.613 171.106 271.113H305.616V312.45H126.269Z"
      fill="currentColor"
    />
    <!-- "halves" translatable text -->
    <text
      x="215"
      y="392"
      text-anchor="middle"
      font-family="KingsFont, Arial, sans-serif"
      font-size="62"
      font-weight="700"
      fill="white"
      letter-spacing="6"
    >
      {{ String($t("howToPlay.section.duration.halves")).toUpperCase() }}
    </text>
  </svg>
</template>
